var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v("AquaDuct Roof & Gutters")]),_c('v-card-subtitle',[_vm._v("What our customers say")]),_c('v-card-text',[_vm._v("AquaDuct is great!")]),_c('v-card-actions',[_vm._v("buttons")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }